import type { ReactElement } from 'react';
import { PlatformRole, type UserDto } from '@gr/core/accounts/identity/dto';
import { useT } from '../../../../app/di';
import { Card } from '../../../../ui-kit/Card/Card';

/** Учётная запись в профиле: имя, логин, роль в системе. */
export function AccountSummary({ user }: { user: UserDto }): ReactElement {
  const { t } = useT();
  return (
    <Card title={t('identity.profile.account')}>
      <div className="u-stack u-gap-1">
        <strong className="u-truncate">{user.displayName}</strong>
        <p className="u-muted">{t('identity.profile.loginLabel', { login: user.login })}</p>
        <p className="u-muted">{user.platformRole === PlatformRole.Admin ? t('identity.profile.roleAdmin') : t('identity.profile.roleUser')}</p>
      </div>
    </Card>
  );
}
